export class RepMailPersonEntity{
    id:number;
    mailId:number;
    personId:number;

    constructor(){}
}